import UserActivityLoggingApi from "core/services/user-activity-logging.service";

export const activityLogArea = {
    amountToPay: "AmountToPay",
    auth: "Auth",
    clearError: "ClearError",
    customerAccount: "CustomerAccount",
    dashboard: "Dashboard",
    email: "Email",
    freskDesk: "FreskDesk",
    invoices: "Invoices",
    mahPayment: "MahPayment",
    otp: "Otp",
    payAt: "PayAt",
    payment: "Payment",
    permissions: "Permissions",
    products: "Products",
    statements: "Statements",
    users: "Users",
    invites: "Invites",
    changePackage: "ChangePackage"
}

export const activityLogEvent = {
    create: "Create",
    read: "Read",
    update: "Update",
    delete: "Delete",
    execute: "Execute",
    download: "Download"
}

export class UserActivityLogger {
    api = new UserActivityLoggingApi();
    area = "";

    constructor(area: string) {
        this.area = area;
    }

    log(action: string, data: any = null) {
        this.api.logActivityAsync(this.area, action, data);
    }

    update(data: any = null) {
        this.log(activityLogEvent.update, data);
    }

    delete(data: any = null) {
        this.log(activityLogEvent.delete, data);
    }

    read(data: any = null) {
        this.log(activityLogEvent.read, data);
    }

    create(data: any = null) {
        this.log(activityLogEvent.create, data);
    }

    download(data: any = null) {
        this.log(activityLogEvent.download, data);
    }

    execute(data: any = null) {
        this.log(activityLogEvent.execute, data);
    }
}

export default { UserActivityLogger, activityLogArea, activityLogEvent }
